import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import {
  ClientReadableText,
  KhattabaAvailabilityCapacityUpdate,
  KhattabatAvailibilityCapacityChanger
} from "../../core/et3-table/UserCustomHelpers";
import { getReadableSearchCriteria } from "../../helpers/et3-matchmaking-criteria-helper";

export const KHATTABAT_REMUNERATIONS: GridColDef[] = [
  {
    headerName: "Admin Id",
    field: "adminID"
  },
  {
    headerName: "Full Name",
    field: "name"
  },
  {
    headerName: "Successful Monthly Sub",
    field: "subscribedClientsBasePhaseCount"
  },
  {
    headerName: "Successful Weekly Sub",
    field: "subscribedClientsIntroductoryPhaseCount"
  },
  {
    headerName: "Refunded Monthly Sub",
    field: "refundedClientsBasePhaseCount"
  },
  {
    headerName: "Refunded Weekly Sub",
    field: "refundedClientsIntroductoryPhaseCount"
  },
  {
    headerName: "Remuneration in $",
    field: "khattabatAdminRemuneration"
  }
];

export const KHATTABAT_AVAILABILITY: GridColDef[] = [
  {
    headerName: "Admin Id",
    field: "adminId"
  },
  {
    headerName: "Full Name",
    field: "fullname"
  },
  {
    headerName: "RC Capacity",
    field: "capacity",
    flex: 2,
    renderCell: (params: GridValueGetterParams) => {
      return (
        <KhattabatAvailibilityCapacityChanger
          updatedCapacityValue={params.row.updatedCapacityCount}
          adminId={params.row.adminId}
        />
      );
    }
  },
  {
    headerName: "Total Count Paid Client",
    field: "totalCountPaidClient"
  },
  {
    headerName: "Total Active",
    field: "totalActive"
  },
  {
    headerName: "Update",
    field: "updateState",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <KhattabaAvailabilityCapacityUpdate
          adminID={params.row.adminId}
          originalCapacityCount={params.row.capacity}
          updatedCapacityCount={params.row.updatedCapacityCount}
          totalActiveClients={params.row.totalActive}
        />
      );
    }
  }
];

export const KHATTABAT_DATA_COLLECTION_HEADERS: GridColDef[] = [
  {
    headerName: "Khattaba Name",
    field: "khattabaName"
  },
  {
    headerName: "Total Clients",
    field: "totalClients"
  },
  {
    headerName: "Total Active Clients",
    field: "totalActiveClients"
  },
  {
    headerName: "No Quality 102 for active",
    field: "activeUsersWithoutOrLowQualityOneOTwo"
  }
];

export const ALL_KHATTABAT_CLIENTS_DATA_HEADERS: GridColDef[] = [
  {
    headerName: "UserID",
    field: "userID"
  },
  {
    headerName: "OS",
    field: "OS"
  },
  {
    headerName: "Username",
    field: "username"
  },
  {
    headerName: "Gender",
    field: "gender"
  },
  {
    headerName: "Khattaba",
    field: "khattaba"
  },
  {
    headerName: "Type of Marriage",
    field: "typeOfMarriage"
  },
  {
    headerName: "Age",
    field: "age"
  },
  {
    headerName: "Nationality",
    field: "nationality"
  },
  {
    headerName: "Location",
    field: "location"
  },
  {
    headerName: "City",
    field: "city"
  },
  {
    headerName: "Created On",
    field: "createdOn"
  },
  {
    headerName: "First Purchase Type",
    field: "firstPurchaseType"
  },
  {
    headerName: "First Purchase Date",
    field: "firstPurchaseDate"
  },
  {
    headerName: "Weekly Refund",
    field: "weeklyRefund"
  },
  {
    headerName: "Monthly Refund",
    field: "monthlyRefund"
  },
  {
    headerName: "Refunds",
    field: "refund"
  },
  {
    headerName: "Renew Week to Month",
    field: "renewWeekToMonth"
  },
  {
    headerName: "Renew Month to Month",
    field: "renewMonthToMonth"
  },
  {
    headerName: "Renewals",
    field: "renewal"
  },
  {
    headerName: "Cancelled",
    field: "cancelled"
  },
  {
    headerName: "Cancellation Date",
    field: "cancellationDate"
  },
  {
    headerName: "Active",
    field: "active"
  },
  {
    headerName: "102",
    field: "oneOTwoNumber"
  },
  {
    headerName: "Quality 102",
    field: "oneOTwoQualityNumber"
  },
  {
    headerName: "Last Renewal Date",
    field: "lastRenewalDate"
  },
  {
    headerName: "Last Purchase Date",
    field: "lastPurchaseDate"
  },
  {
    headerName: "Last Succesfull Refund Date",
    field: "latestSuccessfullRefundDate"
  },
  {
    headerName: "Expiry date of the most recent subscription",
    field: "vipUntilAlkhattabatDate"
  }
];

export const KHATTABAT_FUNNEL_STATS_HEADERS: GridColDef[] = [
  { headerName: "Apply", field: "apply" },
  { headerName: "To Be Informed", field: "toBeInformed" },
  { headerName: "Applied", field: "applied" },
  { headerName: "Do Not Inform", field: "doNotInform" },
  { headerName: "Accepted", field: "accepted" },
  { headerName: "Rejected", field: "rejected" },
  { headerName: "Deleted", field: "deleted" },
  { headerName: "Ongoing", field: "ongoing" },
  { headerName: "Paying", field: "paying" },
  { headerName: "Cancelled", field: "cancelled" },
  { headerName: "Refunded", field: "refunded" },
  { headerName: "Active", field: "active" }
];

export const KHATTABAT_MATCHMAKING_AUDIT_HEADERS: GridColDef[] = [
  { headerName: "Khattaba Name", field: "khattabaName", width: 180 },
  { headerName: "Date/Time", field: "requestedOn", width: 180 },
  { headerName: "Client UserID", field: "clientUserId", width: 130 },
  { headerName: "Number of Matches", field: "matchesCount", width: 130 },
  { headerName: "Number of Accepted", field: "acceptedCount", width: 130 },
  {
    headerName: "Search Criteria",
    field: "searchCriteria",
    renderCell: (params: GridValueGetterParams) => {
      return (
        <ClientReadableText
          text={getReadableSearchCriteria(params.row.searchCriteria)}
        />
      );
    }
  }
];
